import { render, staticRenderFns } from "./LprIcon.vue?vue&type=template&id=2ae366a0&scoped=true"
import script from "./LprIcon.vue?vue&type=script&lang=js"
export * from "./LprIcon.vue?vue&type=script&lang=js"
import style0 from "./LprIcon.vue?vue&type=style&index=0&id=2ae366a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae366a0",
  null
  
)

export default component.exports